
import { CommonEnums } from '../common.enums';
import { Conn_Db_Obj_Lnk } from '../models/conn_Db_Obj_Lnk';

export class Conn_Db_Obj_LnksUtil {
    private static instance: Conn_Db_Obj_LnksUtil;
    conn_Db_Obj_Lnk: Conn_Db_Obj_Lnk;

    static getInstance() {
        if (!Conn_Db_Obj_LnksUtil.instance) {
            Conn_Db_Obj_LnksUtil.instance = new Conn_Db_Obj_LnksUtil();
        }

        return Conn_Db_Obj_LnksUtil.instance;
    }

    /**
    * Conn_Db_Obj_LnksUtil is a singleton class, so use Conn_Db_Obj_LnksUtil.getInstance() method instead of creating new Conn_Db_Obj_LnksUtil().
    */
    private constructor() {
        this.conn_Db_Obj_Lnk = new Conn_Db_Obj_Lnk();
    }

    setEmptyELProperties(conn_Db_Obj_Lnk) {
        conn_Db_Obj_Lnk.extract_Properties.splice(0, conn_Db_Obj_Lnk.extract_Properties.length);
        conn_Db_Obj_Lnk.extractPropertyTypes.splice(0, conn_Db_Obj_Lnk.extractPropertyTypes.length);
        conn_Db_Obj_Lnk.sel_Extract_PropertyType_Cd = '';

        conn_Db_Obj_Lnk.load_Properties.splice(0, conn_Db_Obj_Lnk.load_Properties.length);
        conn_Db_Obj_Lnk.loadPropertyTypes.splice(0, conn_Db_Obj_Lnk.loadPropertyTypes.length);
        conn_Db_Obj_Lnk.sel_Load_PropertyType_Cd = '';
    }

    add(): Conn_Db_Obj_Lnk {

        return null;
    }

    delete(): void {

    }

    setConn_Db_obj_lnk_Defaults(conn_Db_Obj_Lnk: Conn_Db_Obj_Lnk): void {
        conn_Db_Obj_Lnk.conn_Id = CommonEnums.defaults.LONG_VAL;
        conn_Db_Obj_Lnk.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        conn_Db_Obj_Lnk.dxMp_Inst_Id = CommonEnums.defaults.LONG_VAL;
        conn_Db_Obj_Lnk.obj_Id = CommonEnums.defaults.LONG_VAL;
        conn_Db_Obj_Lnk.conn_Db_Id = CommonEnums.defaults.LONG_VAL;
        conn_Db_Obj_Lnk.obj_Cd = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.conn_Nm = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.conn_Db_Nm = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.objNm = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.imageUrl = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.fldr_Id = CommonEnums.defaults.LONG_VAL;
        conn_Db_Obj_Lnk.fldrNm = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.extract_Properties = new Array<any>();
        conn_Db_Obj_Lnk.load_Properties = new Array<any>();
        conn_Db_Obj_Lnk.sel_Extract_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.sel_Load_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.extractPropertyTypes = new Array<any>();
        conn_Db_Obj_Lnk.loadPropertyTypes = new Array<any>();
        conn_Db_Obj_Lnk.dbTyp_Id = CommonEnums.defaults.LONG_VAL;
        conn_Db_Obj_Lnk.partition_Properties = new Array<any>();
        conn_Db_Obj_Lnk.host = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.port = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.conn_Usr = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.group_Id = CommonEnums.defaults.LONG_VAL;
        conn_Db_Obj_Lnk.databaseNm = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.conn_Db_FriendlyName = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.copy_Sel_Extract_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.copy_Sel_Load_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.conn_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        conn_Db_Obj_Lnk.secKeyTab = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.platform = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.hiveServe2HACnf_Flg = CommonEnums.defaults.STRING_VAL_NO;
        conn_Db_Obj_Lnk.zookeeper_Quorum_Host = CommonEnums.defaults.STRING_EMPTY;
        conn_Db_Obj_Lnk.metaData_Properties = new Array<any>();
    }

    copy(conn_Db_Obj_LnksTmp: Array<Conn_Db_Obj_Lnk>): Array<Conn_Db_Obj_Lnk> {
        let conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk> = new Array<Conn_Db_Obj_Lnk>();

        for (let i: number = 0; i < conn_Db_Obj_LnksTmp.length; i++) {
            conn_Db_Obj_Lnks.push(conn_Db_Obj_LnksTmp[i].copy())
        }

        return conn_Db_Obj_Lnks;
    }

    copyFrom(conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>, conn_Db_Obj_LnksTmp: Array<Conn_Db_Obj_Lnk>): void {
        let conn_Db_Obj_Lnk_Map: Map<string, Conn_Db_Obj_Lnk> = new Map();

        let conn_Db_Obj_Lnk_Length: number = conn_Db_Obj_Lnks.length;
        for (let i: number = 0; i < conn_Db_Obj_Lnk_Length; i++) {
            let conn_Db_Obj_Lnk = conn_Db_Obj_Lnks[i];
            let key = conn_Db_Obj_Lnk.conn_Db_Id + "-" + conn_Db_Obj_Lnk.obj_Id;
            conn_Db_Obj_Lnk_Map.set(key, conn_Db_Obj_Lnks[i]);
        }

        conn_Db_Obj_Lnks.splice(0, conn_Db_Obj_Lnks.length);

        let conn_Db_Obj_LnkTmpLength: number = conn_Db_Obj_LnksTmp.length;
        for (let i: number = 0; i < conn_Db_Obj_LnkTmpLength; i++) {
            let conn_Db_Obj_LnkTmp: Conn_Db_Obj_Lnk = conn_Db_Obj_LnksTmp[i] as Conn_Db_Obj_Lnk;
            let key = conn_Db_Obj_LnkTmp.conn_Db_Id + "-" + conn_Db_Obj_LnkTmp.obj_Id;
            let conn_Db: Conn_Db_Obj_Lnk = conn_Db_Obj_Lnk_Map.get(key);
            if (conn_Db) {
                conn_Db.copyFrom(conn_Db_Obj_LnkTmp);
            } else {
                conn_Db = Conn_Db_Obj_Lnk.parse(JSON.parse(JSON.stringify(conn_Db_Obj_LnkTmp)));
            }

            conn_Db_Obj_Lnks.push(conn_Db);
        }
    }

    updateConn_Db_Obj_Lnk(conn_Db_Obj_Lnk: Conn_Db_Obj_Lnk, connection: any): void {
        if (conn_Db_Obj_Lnk.conn_Id == connection.conn_Id &&
            conn_Db_Obj_Lnk.conn_Db_Id == connection.conn_Db_Id &&
            conn_Db_Obj_Lnk.dbTyp_Id == connection.dbTyp_Id)
            return;

        conn_Db_Obj_Lnk.conn_Id = connection.conn_Id;
        conn_Db_Obj_Lnk.conn_Valid_Cd = connection.valid_Cd;
        conn_Db_Obj_Lnk.conn_Db_Id = connection.conn_Db_Id != -1 ? connection.conn_Db_Id : connection.conn_Id;

        conn_Db_Obj_Lnk.conn_Nm = connection.connNm;
        //conn_Db_Obj_Lnk.conn_Db_Nm = connection.conn_Db_Nm ? connection.conn_Db_Nm : connection.conn_DbNm;
        conn_Db_Obj_Lnk.dbTyp_Id = connection.dbTyp_Id;
        conn_Db_Obj_Lnk.conn_Db_FriendlyName = connection.conn_Db_FriendlyName;

        conn_Db_Obj_Lnk.fldr_Id = connection.fldr_Id;
    }

    compare(conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>, conn_Db_Obj_LnksTmp: Array<Conn_Db_Obj_Lnk>): string {
        let conn_Db_Obj_LnkLength: number = conn_Db_Obj_Lnks.length;
        let conn_Db_Obj_LnkTmpLength: number = conn_Db_Obj_LnksTmp.length;

        if (conn_Db_Obj_LnkLength != conn_Db_Obj_LnkTmpLength) {
            return 'Conn_Dbs length is different';
        }

        for (let i: number = 0; i < conn_Db_Obj_LnkTmpLength; i++) {
            let conn_Db_Obj_Lnk = conn_Db_Obj_Lnks[i];
            let conn_Db_Obj_LnkTmp = this.getConn_Db_Obj_LnkByCode(conn_Db_Obj_Lnk, conn_Db_Obj_LnksTmp);
            if(conn_Db_Obj_LnkTmp == undefined) {
                return "conn_Db_Obj_Lnk has been changed.";
            }
            if (conn_Db_Obj_Lnk.compare(conn_Db_Obj_LnkTmp) != '') {
                return "conn_Db_Obj_Lnks [" + i + '] is not equal.'
            }
        }

        return '';
    }

    getConn_Db_Obj_LnkByCode(conn_Db_Obj_Lnk: Conn_Db_Obj_Lnk, conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>): Conn_Db_Obj_Lnk {
        for (let i: number = 0; i < conn_Db_Obj_Lnks.length; i++) {
            if (conn_Db_Obj_Lnks[i].obj_Cd == conn_Db_Obj_Lnk.obj_Cd &&
                conn_Db_Obj_Lnks[i].obj_Id == conn_Db_Obj_Lnk.obj_Id &&
                conn_Db_Obj_Lnks[i].conn_Id == conn_Db_Obj_Lnk.conn_Id &&
                conn_Db_Obj_Lnks[i].conn_Db_Id == conn_Db_Obj_Lnk.conn_Db_Id ) return conn_Db_Obj_Lnks[i];
        }
    }

    toString(conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>): string {
        let str: string = 'Conn_Db_Obj_Lnk length: ' + conn_Db_Obj_Lnks.length + ' ';

        for (let i: number = 0; i < conn_Db_Obj_Lnks.length; i++) {
            str += conn_Db_Obj_Lnks[i].toString();
        }

        return str;
    }
}